<script>
import ContactForm from '../../components/contactForm.vue';
import FilterMenu from '../../components/filterMenu.vue';
import GalleryInfo from '../../components/galleryInfo.vue';
import Loading from '../../components/loading.vue';
import OnlineBanner from '../../components/onlineBanner.vue';

export default {
    name: "online",
    data() {
        return {
            banner: [],
            artist: [],
            artistActiveIndex: [],
            category: [],
            categoryActiveIndex: [],
            topList: [],
            list: [],
            page: 1,
            allPage: 1,
            isLoading: false,
            isShowFilter: false,
            isShowSort: false,
        };
    },
    computed: {},
    components: {
        ContactForm,
        GalleryInfo,
        OnlineBanner,
        FilterMenu,
        Loading
    },
    mounted() {
        this.getCategory();
        this.getList();
    },
    destroyed() {},
    watch: {
        '$route': {
            handler: function () { 
                this.list = [];
                this.page = 1;
                this.allPage = 1;
                this.getList();

                this.isShowFilter = false;
                this.isShowSort = false;
            }
        },
    },
    methods: {
        // 分类
        getCategory() { 
            this.$store.dispatch('getGalleryCategory', {
                type: 3
            }).then((result) => {
                if (result.code == 100) { 
                    // 置顶和banner
                    this.banner = result.data.banner_exhibition;
                    // this.banner = result.data.banner;
                    // 筛选
                    this.artist = [
                        { name: '艺术家', children: result.data.artist },
                    ]
                    this.category = result.data.category.map(v => {
                        return {
                            ...v,
                            children: [...v.item]
                        }
                    })

                    this.getCheckedIndex();
                }
            }).catch((err) => {
                
            });
        },
        getCheckedIndex() {
            // 路由是否有艺术家id
            if (this.artist.length > 0) { 
                if (this.$route.query.artist) { 
                    // 找到对应的索引
                    let index = this.artist[0].children.findIndex(v => v.id == this.$route.query.artist);
                    if (index != -1) { 
                        // 找到了
                        this.artistActiveIndex = [index];
                    } else {
                        // 没找到
                        this.artistActiveIndex = [null];
                    }
                } else {
                    // 路由没有艺术家id
                    this.artistActiveIndex = [null];
                }
            }
            
            // 路由是否有筛选id
            if (this.category.length > 0) { 
                if (this.$route.query.id) { 
                    const ids = this.$route.query.id.split(',');
                    this.categoryActiveIndex = this.category.map((v, i) => {
                        const checked = v.children.findIndex(item => {
                            return ids.findIndex(v => v == item.id) != -1
                        })
                        return checked != -1 ? checked : null;
                    });
                } else {
                    // 路由没有筛选id
                    this.categoryActiveIndex = this.category.map(() => null);
                }
            }
        },
        getList() { 
            if (this.isLoading) { 
                return;
            }
            let { query } = this.$route;
            this.isLoading = true;
            this.$store.dispatch('getGalleryList', {
                type: 3,
                artist_id: query.artist ? query.artist : '',
                category_ids: query.id ? query.id : '',
                limit: 9,
                page: this.page,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.list = this.list.concat(result.data.list);
                    this.allPage = result.data.last_page;

                    this.getCheckedIndex();
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getGalleryList();
        },
        changeArtist(value) { 
            let query = {};
            if (value[0] != null) { 
                query.artist = `${this.artist[0].children[value[0]].id}`;
            }
            if (this.$route.query.id) { 
                query.id = this.$route.query.id;
            }
            this.$router.push({
                path: '/gallery/online',
                query
            })
        },
        changeCategory(value) { 
            let query = {};
            if (this.$route.query.artist) { 
                query.artist = this.$route.query.artist;
            }
            let arr = [];
            // 根据索引获取id数组
            value.forEach((v, i) => {
                if (v != null) { 
                    arr.push(this.category[i].children[v].id);
                }
            })
            const ids = arr.join(',');
            if (ids != '') { 
                query.id = ids;
            }
            this.$router.push({
                path: '/gallery/online',
                query
            })
        },
    },
};
</script>

<template>
    <div class="online">
        <OnlineBanner :data="banner"/>
        <div class="only_mobile">
            <div class="filter_tabs flex">
                <div class="item" :class="{active: isShowFilter}" @click="isShowFilter = !isShowFilter">
                    <div class="name">筛选</div>
                </div>
                <!-- <div class="item" :class="{active: isShowSort}" @click="isShowSort = !isShowSort">
                    <div class="name">{{ sort[sortValue].name }}</div>
                </div> -->
            </div>
            <template v-if="isShowFilter">
                <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeArtist"/>
                <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeCategory"/>
            </template>
            <!-- <FilterMenu v-if="isShowFilter" :data="detail.children" v-model="checkedActiveIndex" @change="changeChecked"/> -->
            <!-- <div class="sort" v-if="isShowSort">
                <div class="item" v-for="(item, index) in sort" :key="index" @click="sortValue = index">{{ item.name }}</div>
            </div> -->
        </div>
        <div class="main">
            <div class="layout_main">
                <p class="title only_pc">过往展览</p>
                <div class="wrapper flex">
                    <div class="filter only_pc" v-if="artist.length > 0 || category.length > 0">
                        <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeArtist"/>
                        <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeCategory"/>
                    </div>
                    <div class="content">
                        <div class="list flex flex_wrap">
                            <router-link class="item" v-for="(item, index) in list" :key="index" :to="`/gallery/online/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <p class="name">{{ item.tag }}</p>
                                <p class="text">{{ item.name }}</p>
                                <p class="time">{{ item.start_time }} - {{ item.end_time }}</p>
                            </router-link>
                        </div>
                        <Loading v-if="isLoading"/>
                        <p class="no_more" v-else-if="list.length == 0">暂无更多内容</p>
                        <p class="no_more" v-else-if="page == allPage">已经到底了</p>
                        <div class="flex justify_center" v-else>
                            <div class="btn_show_all layout_flex_center" @click="getMore">展示更多</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ContactForm from="画展"/>
        <GalleryInfo/>
    </div>
</template>

<style scoped lang="scss">
.main{
    border-top: 1px solid #999;
    padding: .4rem 0;
    @media only screen and (max-width: 750px) {
        padding: .3rem 0;
        border-top: none;
    }
}
.filter_tabs{
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
    height: .7rem;
    .item{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #999;
        &.active{
            &::after{
                transform: translate(0, 25%) rotate(-135deg);
            }
        }
        &:last-child{
            border-right: none;
        }
        .name{
            text-align: center;
        }
        &::after{
            content: "";
            display: block;
            width: .14rem;
            height: .14rem;
            border-right: 1px solid #999;
            border-bottom: 1px solid #999;
            transform: translate(0, -25%) rotate(45deg);
            margin-left: .2rem;
        }
    }
}
.sort{
    padding: .3rem .6rem;
    border-bottom: 1px solid #999;
    .item{
        line-height: .6rem;
        font-size: .32rem;
    }
}
.title{
    font-size: .25rem;
    font-weight: bold;
    margin-bottom: .2rem;
}
.wrapper{
    gap: .5rem;
}
.content{
    flex: 1;
}
.list{
    gap: .39rem;
    .item{
        width: 2.8rem;
        font-size: .2rem;
        line-height: 1.6;
        .cover{
            height: 0;
            padding-bottom: 100%;
            margin-bottom: .2rem;
        }
    }
    @media only screen and (max-width: 750px) {
        gap: .3rem;
        flex-direction: column;
        .item{
            width: 100%;
            text-align: center;
            .cover{
                padding-bottom: 65.21%;
            }
            .name{
                font-size: .26rem;
            }
            .text{
                font-size: .32rem;
            }
            .time{
                font-size: .22rem;
            }
        }
    }
}
.btn_show_all{
    font-size: .2rem;
    border: 1px solid #666;
    color: #666;
    height: .48rem;
    padding: 0 .1rem;
    margin: .4rem auto 0;
    cursor: pointer;
}
</style>